export const siteContent = {
    brand: "CZECH ENERGOSPACE",
    motto: "Komplexní řešení pro energetiku, kybernetickou bezpečnost, telekomunikace a projektovou logistiku.",
    homepage: {
        hero: {
            title: "ENERGOSPACE",
            headline: "Komplexní řešení pro energetiku, kybernetickou bezpečnost, telekomunikace a projektovou logistiku.",
            lead: "Jeden partner pro logistiku, energetiku, IT bezpečnost, telekomunikace a technologické projekty."
        },
        proofPoints: [
            "23 let zkušeností",
            "6 600 m² logistických ploch",
            "Projekty po celé EU",
            "Energetika",
            "NIS2",
            "Telekomunikace",
            "Projektová logistika"
        ],
        whyItems: [
            {
                title: "23 let zkušeností",
                items: [
                    "logistika a skladování",
                    "průmyslové dodávky",
                    "energetika",
                    "telekomunikace",
                    "kybernetická bezpečnost",
                    "projektové řízení"
                ]
            },
            {
                title: "Vlastní logistické zázemí",
                items: [
                    "logistický areál NOBI v Kličanech u Prahy",
                    "3 600 m² krytých skladových ploch",
                    "3 000 m² venkovních manipulačních ploch",
                    "vlastní manipulační technika",
                    "konsolidace dodávek z celé Evropy"
                ]
            },
            {
                title: "Evropská působnost",
                text: "Koordinujeme výrobu, kontrolu kvality, skladování, přepravu a montáže projektů v rámci celé Evropské unie prostřednictvím ověřené sítě partnerů."
            }
        ],
        finalStatement: "ENERGOSPACE – jeden partner pro logistiku, energetiku, IT bezpečnost a technologické projekty."
    },
    contact: {
        status: "Kontaktní údaje",
        title: "Kontakt",
        lead: "CZECH ENERGOSPACE, a.s. | IČO 26759594",
        email: "info@energospace.cz",
        locations: [
            {
                title: "Sídlo firmy",
                lines: ["U hranic 3221/18", "Praha 10"],
                mapQuery: "U hranic 3221/18, Praha 10"
            },
            {
                title: "Sklad",
                lines: ["Skladový areál NOBI", "Břežanská 90, 250 69", "Klíčany Vodochody"],
                mapQuery: "Skladový areál NOBI, Břežanská 90, 250 69 Klíčany Vodochody"
            },
            {
                title: "Provozovna",
                lines: ["Kanceláře společnosti", "V Olšinách 1391/11", "Praha 10"],
                mapQuery: "V Olšinách 1391/11, Praha 10"
            }
        ]
    }
};

export const pendingContent = {
    contact: {
        status: "partial_client_data",
        missingFields: ["Telefon"]
    },
    approvals: [
        "konkrétní kontaktní údaje",
        "schválení zákaznických log",
        "práva k fotkám s rozpoznatelnými lidmi",
        "potvrzení finální navigace, pokud se ještě změní"
    ],
    legacyConflicts: []
};
